'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = createYieldEffectMiddleware;

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _isGenerator = require('is-generator');

var _isGenerator2 = _interopRequireDefault(_isGenerator);

var _isPromise = require('is-promise');

var _isPromise2 = _interopRequireDefault(_isPromise);

var _put = require('./effects/put');

var _put2 = _interopRequireDefault(_put);

var _call = require('./effects/call');

var _call2 = _interopRequireDefault(_call);

var _fork = require('./effects/fork');

var _fork2 = _interopRequireDefault(_fork);

var _join = require('./effects/join');

var _join2 = _interopRequireDefault(_join);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 *
 * @param customEffectProcessors - object where keys are effectTypes and values are effectProcessors
 * @returns {function} yieldEffectMiddleware
 */
function createYieldEffectMiddleware() {
  var _extends2;

  var customEffectProcessors = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  var effectProcessors = _extends((_extends2 = {}, _defineProperty(_extends2, _put.TYPE, _put.processor), _defineProperty(_extends2, _call.TYPE, _call.processor), _defineProperty(_extends2, _fork.TYPE, _fork.processor), _defineProperty(_extends2, _join.TYPE, _join.processor), _extends2), customEffectProcessors);

  var effectGeneratorProcessor = createEffectGeneratorProcessor(effectProcessors);

  return function yieldEffectMiddleware(_ref) {
    var dispatch = _ref.dispatch;

    return function (next) {
      return function (action) {
        if (!(0, _isGenerator2.default)(action)) {
          return next(action);
        }

        return effectGeneratorProcessor(action, { dispatch: dispatch });
      };
    };
  };
}

function createEffectGeneratorProcessor(effectProcessors) {

  return function effectGeneratorProcessor(effectGenerator, _ref2) {
    var dispatch = _ref2.dispatch;


    return Promise.resolve(handlePreviousEffectResult());

    function handlePreviousEffectResult(prevEffectResult) {
      var _effectGenerator$next = effectGenerator.next(prevEffectResult);

      var value = _effectGenerator$next.value;
      var done = _effectGenerator$next.done;


      if (done) {
        return value; // we consumed all effects, finishing
      }

      return processEffect(value);
    }

    function handlePreviousEffectError(prevEffectError) {
      var _effectGenerator$thro = effectGenerator.throw(prevEffectError);

      var value = _effectGenerator$thro.value;
      var done = _effectGenerator$thro.done;


      if (done) {
        return value; // we consumed all effects, finishing
      }

      return processEffect(value);
    }

    function processEffect(effect) {
      var effectProcessor = effectProcessors[effect.type];

      (0, _invariant2.default)(effectProcessor, 'cannot find effect processor for effect with type: ' + effect.type);

      var result = effectProcessor(effect, { dispatch: dispatch, effectGeneratorProcessor: effectGeneratorProcessor });

      (0, _invariant2.default)((0, _isPromise2.default)(result), 'effect processor should always return promise, but received: ' + result);

      return result.then(handlePreviousEffectResult, handlePreviousEffectError);
    }
  };
}


// WEBPACK FOOTER //
// ./node_modules/redux-yield-effect/lib/createYieldEffectMiddleware.js